import PropTypes from 'prop-types';
import React from 'react';
import SavedJobActionButtons from './SavedJobActionButtons.react';

const DetailHeader = ({ savedJobId }) => (
  <div className='saved-job-detail-header'>
    <h5>Job Details</h5>
    <SavedJobActionButtons savedJobId={savedJobId} />
  </div>
);

export default DetailHeader;

DetailHeader.propTypes = {
  savedJobId: PropTypes.number,
};
